import { useEffect } from "react";

export default function SourceCodeComponent({ data }) {
  // Convert tabs to spaces
  const normalized = data.rich_text[0].plain_text.replace(/\t/g, "  ");
  
  // Simply trim the start and end, don't dedent
  const sourcecode = normalized.trim();
  
  const language = data.language;

  useEffect(() => {
    if (window.Prism) {
      window.Prism.highlightAll();
    }
  }, []);

  return (
    <div style={{ padding: "24px 0px" }}>
      <span className="sourcecodeLanguageContainer">
        <span style={{ backgroundColor: "var(--terminal)" }}>
          <p className="sourcecodeLanguage">{language}</p>
        </span>
        <span className="topSpan" />
      </span>

      <div className="sourcecode">
        <pre style={{ whiteSpace: "pre" }}>{sourcecode}</pre>
      </div>
    </div>
  );
}
